var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import { jsx as _jsx } from "react/jsx-runtime";
export var Insurance = function (_a) {
    var props = __rest(_a, []);
    return (_jsx("svg", __assign({ viewBox: "0 0 24 24", fill: "none", xmlns: "http://www.w3.org/2000/svg" }, props, { children: _jsx("path", { fillRule: "evenodd", clipRule: "evenodd", d: "M12.6675 0.216755C12.3654 0.0489643 11.9982 0.0489643 11.6962 0.216755L2.77055 5.17543C2.45309 5.3518 2.2562 5.68642 2.2562 6.04959C2.2562 15.6187 8.4811 21.8195 11.6604 23.7624C11.9805 23.958 12.3832 23.958 12.7033 23.7624C15.8825 21.8195 22.1074 15.6187 22.1074 6.04959C22.1074 5.68642 21.9105 5.3518 21.5931 5.17543L12.6675 0.216755ZM12.1818 21.7134C9.34908 19.7327 4.49627 14.4749 4.26479 6.63322L12.1818 2.23487L20.0988 6.63322C19.8674 14.4749 15.0146 19.7327 12.1818 21.7134ZM15.8641 10.7236C16.2547 10.3331 16.2547 9.69995 15.8641 9.30943C15.4736 8.91891 14.8404 8.91891 14.4499 9.30943L11.1901 12.5693L9.91371 11.2929C9.52319 10.9024 8.89002 10.9024 8.4995 11.2929C8.10898 11.6834 8.10898 12.3166 8.4995 12.7071L10.483 14.6906C10.6705 14.8781 10.9249 14.9835 11.1901 14.9835C11.4553 14.9835 11.7096 14.8781 11.8972 14.6906L15.8641 10.7236Z", fill: "currentColor" }) })));
};
